import React from 'react';
import { useTranslation } from 'react-i18next';
import './Aboute.css';
export default function About() {
  const {
    t
  } = useTranslation();
  return <section className="about-container" id="aboute"><h2>{t('about_us_title')}</h2><p>{t('agency.intro')}</p></section>;
}
